import axiosInstance from "../../routes/axiosConfig";

const employeeDataService = {
  getAllEmployees: async () => {
    try {
      const response = await axiosInstance.get("/employees");
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar dados de empregados/usuários:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getMe: async () => {
    const response = await axiosInstance.get("/employees/me");
    return response.data;
  },
};

export default employeeDataService;
